import ModalGuardInner from './ModalGuardInner';

export default {
  ReactComponent: ModalGuardInner,
  bindings: {
    premiumModalName: '<',
    premiumFeatureName: '<',
    premiumFeatureAccessLevel: '<',
    currentUser: '<',
    goToBilling: '&',
    onDismiss: '&',
    purchasePlan: '&',
  },
};
